import React from "react";
import { Chip } from "@mui/material";
import { size, typography } from "theme/tokens";
import useAllFlightRequests from "./useAllFlightRequests";

/*
  "New" flight requests, for the CRM: a request round a PARTNER raised that is
  still `requested` — nobody at Zenvoya has quoted or completed it yet.
  Opening it does not clear it; sending a quote (or approving / completing it)
  moves the status on, and that is what takes it off.
*/

// The sidebar count looks less often than the Requests page itself.
const COUNT_POLL_MS = 120000;

/** Is this request chain's latest round waiting on Zenvoya's first answer? */
export const isNewFlightRequest = (chain) => {
  const r = chain?.latest;
  return !!r && r.status === "requested" && r.requestedBy?.userType === "PARTNER";
};

/** "New" next to a request id. */
export function NewRequestPill() {
  return (
    <Chip
      label="New"
      size="small"
      color="error"
      sx={{ height: size[20], fontSize: typography.fontSize[10], fontWeight: typography.fontWeight.bold }}
    />
  );
}

/** The CRM sidebar's count of new flight requests; nothing when there are none. */
export function NewFlightRequestsCount() {
  const { chains } = useAllFlightRequests({ pollMs: COUNT_POLL_MS });
  const count = chains.filter(isNewFlightRequest).length;
  if (!count) return null;
  return (
    <Chip
      label={count}
      size="small"
      color="error"
      aria-label={`${count} new flight request${count === 1 ? "" : "s"}`}
      sx={{ ml: 1, height: size[20], fontSize: typography.fontSize[12], fontWeight: typography.fontWeight.bold }}
    />
  );
}
